import RootModel from './root';

const Company = new RootModel({
	path: 'companies',
});

export default Company;
